export default class Validator {
    static WORD_COUNT_LABEL = 'Words Count';
}